import * as React from 'react';

import { ReviewsRealtorPageContainer } from '../../../../shared/components/reviews_realtor_page/container';
import { IContext } from '../../../../shared/store';

export function getReviewsRealtorPage(context: IContext) {
  return <ReviewsRealtorPageContainer context={context} />;
}
